"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgInstagram = function SvgInstagram(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M29 13a6 6 0 016 6v10a6 6 0 01-6 6H19a6 6 0 01-6-6V19a6 6 0 016-6h10zm0 2H19a4 4 0 00-4 4v10a4 4 0 004 4h10a4 4 0 004-4V19a4 4 0 00-4-4zm-4.223 4.01a5 5 0 11-1.467 9.893 5 5 0 011.467-9.892zm-3.413 3.598a3 3 0 105.359 2.698 3 3 0 00-5.36-2.698z",
    id: "instagram_svg__a"
  }));
};

var _default = SvgInstagram;
exports["default"] = _default;